export const TIMELINE_PUSH_SELECTION = 'TIMELINE_PUSH_SELECTION';
export const TIMELINE_POP_SELECTION = 'TIMELINE_POP_SELECTION';

// init
export const ACTION_STARTUP_DATA = 'ACTION_STARTUP_DATA';

// global state management
export const ACTION_SELECT_DEVICE = 'ACTION_SELECT_DEVICE';
export const ACTION_SELECT_TIME_FILTER = 'ACTION_SELECT_TIME_FILTER';
export const ACTION_UPDATE_ROUTE_LIMIT = 'ACTION_UPDATE_ROUTE_LIMIT'
export const ACTION_UPDATE_DEVICES = 'ACTION_UPDATE_DEVICES';
export const ACTION_UPDATE_DEVICE = 'ACTION_UPDATE_DEVICE';
export const ACTION_UPDATE_ROUTE = 'ACTION_UPDATE_ROUTE';
export const ACTION_UPDATE_ROUTE_EVENTS = 'ACTION_UPDATE_ROUTE_EVENTS';
export const ACTION_UPDATE_ROUTE_LOCATION = 'ACTION_UPDATE_ROUTE_LOCATION';
export const ACTION_UPDATE_SHARED_DEVICE = 'ACTION_UPDATE_SHARED_DEVICE';
export const ACTION_UPDATE_DEVICE_ONLINE = 'ACTION_UPDATE_DEVICE_ONLINE';
export const ACTION_UPDATE_DEVICE_NETWORK = 'ACTION_UPDATE_DEVICE_NETWORK';
export const ACTION_UPDATE_DEVICE_RPC = 'ACTION_UPDATE_DEVICE_RPC';
export const ACTION_PRIME_NAV = 'ACTION_PRIME_NAV';
export const ACTION_STREAM_NAV = 'ACTION_STREAM_NAV';
export const ACTION_PRIME_SUBSCRIPTION = 'ACTION_PRIME_SUBSCRIPTION';
export const ACTION_PRIME_SUBSCRIBE_INFO = 'ACTION_PRIME_SUBSCRIBE_INFO';

// playback
export const ACTION_SEEK = 'action_seek';
export const ACTION_PAUSE = 'action_pause';
export const ACTION_PLAY = 'action_play';
export const ACTION_LOOP = 'action_loop';
export const ACTION_BUFFER_VIDEO = 'action_buffer_video';
export const ACTION_RESET = 'action_reset';

// segments
export const ACTION_UPDATE_SEGMENT_RANGE = 'update_segment_range';
export const ACTION_ROUTES_METADATA = 'routes_metadata';

// files
export const ACTION_FILES_URLS = 'files_urls';
export const ACTION_FILES_UPDATE = 'files_update';
export const ACTION_FILES_UPLOADING = 'files_uploading';
export const ACTION_FILES_CANCELLED_UPLOADS = 'files_cancelled_uploads';

// analytics
export const ANALYTICS_EVENT = 'analytics_event';
